import { useEffect, useState } from "react";
import API from "../../../api/baseUrl";
import { serialize, original } from "../../../functions/helper";
// import swal from "sweetalert";

import loader from "../../../assets/loader.svg";
import translate from "../../../functions/translate";

export default function DepositList({ update }) {
  const Login_User_Token = localStorage.getItem("user_login_token");
  const Login_User_cp = localStorage.getItem("user_login_cp");

  const [DepositListState, setDepositListState] = useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [update]);

  const fetchData = async () => {
    try {
      const res = await API.post(
        serialize({
          id: 2628,
          sp_param: `'','','${Login_User_cp}'`,
          Login_User_Token,
          Login_User_cp,
        })
      );
      let resParse = original(res.data, false);

      setDepositListState(resParse);
      setLoading(false);
    } catch (error) {
      // swal("", `${error}`, "warning");
      console.log(error);
    }
  };

  return (
    <div className="deposit-list panel-page__paper_list">
      <div className="deposit-list__title panel-page__paper_list__title">
        <h3>واریزی های ثبت شده ی اخیر</h3>
      </div>
      <div className="overflow">
        {!loading ? (
          <table className="table" style={{ width: "max-content" }}>
            {DepositListState[0] && (
              <thead>
                <tr>
                  {Object.keys(DepositListState[0]).map((item, i) => (
                    <th key={i}>{translate(item)}</th>
                  ))}
                </tr>
              </thead>
            )}
            <tbody>
              {DepositListState.length > 0 ? (
                DepositListState.map((item, index) => (
                  <tr key={index}>
                    {Object.values(item).map((val, i) => (
                      <td key={i}>{val}</td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td>آیتمی برای نمایش وجود ندارد</td>
                </tr>
              )}
            </tbody>
          </table>
        ) : (
          <div className="loader-container">
            <img src={loader} />
          </div>
        )}
      </div>
    </div>
  );
}
